// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"lJT6EUx2_YE1nS9x"};